import EditStorage from './AddStorage';

export default EditStorage;
